import Alpine from "alpinejs";
import collapse from '@alpinejs/collapse'

// import './src/fa/font-awesome-min.css'

import React from "react";
import ReactDOM from "react-dom";
import jQuery from "jquery";
// import ReactComponents from './src/react-components'
import wordlist from "./wordlist";
import { canSpeak } from "./speech";
import PlayerController from "./PlayerController";

Alpine.plugin(collapse);
window.Alpine = Alpine;
Alpine.start();

const $ = jQuery;

wordlist($);

$(() => {
	$(".js-wordlist").wordlist();

	const updateWordlistInstructions = () => {
        if(window.localStorage.getItem("pegagogvarmland-wordlist-instructions-dismissed") || canSpeak("sv")) {
            $(".js-wordlist-instructions").addClass("hidden");
        }
	};

	updateWordlistInstructions();

	if (window.speechSynthesis && window.speechSynthesis.addEventListener) {
		window.speechSynthesis.addEventListener("voiceschanged", updateWordlistInstructions);
	}

	$(".js-wordlist-instructions-dismiss").on('click', () => {
		window.localStorage.setItem("pegagogvarmland-wordlist-instructions-dismissed", "1");
		updateWordlistInstructions();
	});

	$(".js-react-component").each(function () {
		const { "react-component": component, "react-props": props = {} } = $(this).data();
		if (component && ReactComponents[component]) {
			ReactDOM.render(React.createElement(ReactComponents[component], props), this);
		}
	});

    // Init player
    if (document.getElementById('pod-player')) {
        const Controller = new PlayerController();
        Controller.init();
    }
});
